import {signal, WritableSignal} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";

const debug = initDebugger('LagrerIndikator')

/** @deprecated bruk asynkArbeidPågårSignal() */
export class LagrerIndikator implements LagrerIndikatorArbeid {

    lagrer = signal(false);

    /** setter lagrer=true, utfører angitt arbeid, setter lagrer=false */
    async utfør(arbeid: () => Promise<any>): Promise<any> {
        this.lagrer.set(true);
        try {
            return await arbeid();

        } catch (e) {
            debug('Exception i LagrerIndikator.utfør(..) kastet videre', e);
            throw e;

        } finally {
            this.lagrer.set(false);
        }
    }

    /** Setter lagrer=true, utfører angitt arbeid, setter lagrer=false.
     * Svelger exception. */
    async utførOgSvelgException(arbeid: () => Promise<any>): Promise<any> {
        this.lagrer.set(true);
        try {
            return await arbeid();

        } catch (e) {
            debug('Exception i LagrerIndikator.utførOgSvelgException(..) ignorert', e);

        } finally {
            this.lagrer.set(false);
        }
    }
}

export interface LagrerIndikatorArbeid {
    utfør<T>(arbeid: () => Promise<T>): Promise<T>;

    utførOgSvelgException<T>(arbeid: () => Promise<T>): Promise<T>;
}

/** Eksponerer et signal som også implementerer {@link LagrerIndikatorArbeid}.
 *
 * Typisk bruk i kontroller-klasse;
 *
 * lagrer = lagrerSignal();
 * ...
 * metodeSomKallerServer(){
 *     await this.lagrer.utfør(async () => {
 *         ..asynkrone kal
 *     })
 * }
 *
 * @deprecated bruk asynkArbeidPågårSignal()
 */
export function lagrerSignal(): WritableSignal<boolean> & LagrerIndikatorArbeid {
    const indikator = new LagrerIndikator();
    const signalMedLagrerIndikatorArbeid = indikator.lagrer as WritableSignal<boolean> & LagrerIndikatorArbeid;

    signalMedLagrerIndikatorArbeid.utfør = arbeid => indikator.utfør(arbeid);
    signalMedLagrerIndikatorArbeid.utførOgSvelgException = arbeid => indikator.utførOgSvelgException(arbeid);

    return signalMedLagrerIndikatorArbeid;
}
